import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import axiosAdmin from 'utils/axiosAdmin';
import URL from 'config/url';

export const getCommissionReport = createAsyncThunk('COMMISSION REPORT', async (data, thunkAPI) => {
  const response = await axiosAdmin.get(`${URL.GET_AGENCY_COMMISSION}?date=${data}`, data, thunkAPI);
  return response.data;
});

const initialState = {
  isLoading: false,
  commissionReportData: [],
};

export const commissionReportSlice = createSlice({
  name: 'commission',
  initialState,
  reducers: {},
  extraReducers: {
    // get csv data
    [getCommissionReport.pending]: (state) => {
      state.isLoading = true;
      state.commissionReportData = [];
    },
    [getCommissionReport.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.commissionReportData = action.payload.data;
      console.log('state action', state, action);
    },
    [getCommissionReport.rejected]: (state, action) => {
      state.isLoading = false;
      state.commissionReportData = [];
      toast.error(action?.payload?.message);
    },
  },
});

export default commissionReportSlice.reducer;
